// extracted by mini-css-extract-plugin
export default {"link":"MobileNavbar_link__We365","fade":"MobileNavbar_fade__5rWAl"};